import { PriceDetails } from '@/types/price';
import { observer } from 'mobx-react-lite';
import { Capacitie } from '@/types/capacitie';
import { PriceSection } from './PriceSection';
import { useStore } from '@/hooks/useStore';
import { useState, useEffect } from 'react';

export default observer(function PriceList() {
    // state
    const [prices, setPrices] = useState<{ prices: PriceDetails[], capacities: Capacitie[] }>();

    // store
    const {
        capacitieStore: { capacitieList },
        priceStore: { priceEUList }
    } = useStore();

    useEffect(() => {
        if (capacitieList && capacitieList.length > 0 && priceEUList && priceEUList.length > 0) {
            setPrices({ prices: priceEUList, capacities: capacitieList });
        }
    }, [capacitieList, priceEUList]);

    if (!prices?.prices || !prices?.capacities) return null;

    return (
        <div className='flex flex-col gap-5'>
            <div className='leading-[calc(30/14)]'>
                <div className='flex items-center gap-1'>
                    <div className='size-3 bg-primaryWeb'></div>
                    <p className='font-semibold'>当サービスのご利用資格</p>
                </div>
                <p>16歳以上かつ公的な身分証明書をお持ちの方。</p>
                <p className='mt-[15px] text-fs-mid13 leading-[23px]'>
                    【公的な身分証の一例】
                    <br />
                    ・運転免許証、健康保険証、マイナンバーカードなど
                    <br />
                    <br />
                    ※20歳以下のお客様につきましては、親権者様の同意確認を行います。
                    <br />
                    ※また、20歳以下のお客様につきましては、保険適用の特別対応につきレンタル料金に2,000円（税込み）が自動的に加算されます。
                </p>
                {/* <p></p>
                        <p className='mt-4'></p> */}

            </div>
            <div>
                <div className='flex items-center gap-1 mb-5'>
                    <div className='size-3 bg-primaryWeb ' />
                    <p className='font-semibold'>レンタル料金</p>
                </div>
                <div className='flex flex-col gap-[min(20px,5vw)]'>
                    {prices?.prices.map((item, idx) => (
                        <PriceSection key={idx} item={item} capacities={prices.capacities} />
                    ))}
                </div>
            </div>
        </div>

    );
});
